import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';

import { TestimonialCardSkeletonProps } from './TestimonialCardSkeleton.types';

const TestimonialCardSkeleton: React.FC<TestimonialCardSkeletonProps> = ({ className }) => {
  return <Card className={`relative flex flex-column p4 ${className}`}>
    <BaseSkeleton width={180} height={25} className=" mb4" />
    <div className='flex flex-justify'>
      <BaseSkeleton width={60}  height={25} className="mt4" />
      <Skeleton variant='circle' width={36} height={36} />
    </div>
  </Card>;
};

export default TestimonialCardSkeleton;
export { TestimonialCardSkeletonProps };
